export default __webpack_public_path__ + "static/media/PPI-garden-bed-002.1cc94ed7.jpg";